/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Notesupdated2Inputs */

const en_coinvestments_notesupdated2 = /** @type {(inputs: Coinvestments_Notesupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes updated successfully`)
};

/**
* | output |
* | --- |
* | "Notes updated successfully" |
*
* @param {Coinvestments_Notesupdated2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_notesupdated2 = /** @type {((inputs?: Coinvestments_Notesupdated2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Notesupdated2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_notesupdated2(inputs)
});
export { coinvestments_notesupdated2 as "coInvestments_notesUpdated" }